import React, { useState } from "react";
import { withRouter } from "react-router";
import AppContainer from "../AppContainer/AppContainer";

import { useTranslation } from "react-i18next";

import "./quality-check.scss";

const HubInQualityCheck = () => {

    const [IDCheck, setIDCheck] = useState(false);
    const [InQuality, setInQuality] = useState(false);

    const { t, i18n } = useTranslation();

    function toggleInQuality() {
        setInQuality(!InQuality);
    }
    
    function toggleIDCheck() {
        setIDCheck(!IDCheck);
    }

    return (
        <AppContainer>
            <div class="formContainer">
                <div class="formObject withBorder centred title">HUB IN</div>
                <div class="formObject">Collector Name</div>
                <div class="formObject">
                    <div className={"checkbox"}>
                        <i onClick={toggleIDCheck} className={"fal " + (IDCheck ? "fa-check-square" : "fa-square")}></i>
                    </div>
                    <div class="checkboxLabel">Collector ID Check</div>
                </div>
                <div class="formObject">{t("jobNum")}1234</div>
                <div class="formObject withBorder">Clear PET</div>
                <input class="formObject " type="number" min="1" max="100"></input>
                <div class="formObject">
                    <div className={"checkbox"}>
                        <i onClick={toggleInQuality} className={"fal " + (InQuality ? "fa-check-square" : "fa-square")}></i>
                    </div>
                    <div class="checkboxLabel">IN Quality Confirmed</div>
                </div>
                <div className={"formObject centred withBorder " + ((InQuality && IDCheck) ? "accept" : "disabled")}>OK to PAY</div>
            </div>
        </AppContainer>
    );
};

export default withRouter(HubInQualityCheck);